import { render } from "./InvitationPage.vue?vue&type=template&id=2ef9033b&scoped=true"
const script = {}

import "./InvitationPage.vue?vue&type=style&index=0&id=2ef9033b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ef9033b"]])

export default __exports__